import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import { FEEDBACK_TYPES } from '../../constants/feedback.js';
import { BUTTON_PROP_TYPES } from '../Inputs/Button/Button.constants.js';

FEEDBACK_TYPES.SUCCESS;
  var feedbackTypes = _objectWithoutProperties(FEEDBACK_TYPES, ["SUCCESS"]);
var STATUS_FEEDBACK_TYPES = _objectSpread2(_objectSpread2({}, feedbackTypes), {}, {
  LOADING: 'loading'
});
var STATUS_PROP_TYPES = {
  buttonProps: PropTypes.shape(BUTTON_PROP_TYPES),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  testId: PropTypes.string,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(STATUS_FEEDBACK_TYPES))
};
var STATUS_FEEDBACK_TYPES$1 = STATUS_FEEDBACK_TYPES;

export { STATUS_PROP_TYPES, STATUS_FEEDBACK_TYPES$1 as default };
//# sourceMappingURL=status.constants.js.map
